<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save"
    @on-cancel="hide"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="50%"
  >
    <v-row v-if="conditionItems.length == 0" justify="center" align="center">
      <v-col cols="1">
        <v-btn
          tile
          color="primary"
          prepend-icon="mdi-plus"
          outlined
          @click="addAction()"
        >
          {{ $t("Add") }}
        </v-btn>
      </v-col>
    </v-row>
    <div v-for="item in conditionItems" :key="item.uuid">
      <SearchCriteriaCondition
        :ref="`searchCriteriaConditionKey${item.uuid}`"
        :fieldList="fieldList"
        :showSearchOperatorSelect="false"
        :conditionItem="item"
        :clearValue="false"
        @on-condition-item-add="addAction"
        @on-condition-item-remove="removeAction"
      />
    </div>
  </base-modal>
</template>
<script>
import ContentTypeAlertAction from "@/ecm/models/contentType/alerts/ContentTypeAlertAction";
import ConditionItem from "@/ecm/models/search/ConditionItem";
import FieldType from "@/ecm/variables/FieldType";
import SearchService from "@/services/SearchService";
import SearchCriteriaCondition from "@/components/search/SearchCriteriaCondition.vue";
import SearchConstValues from "@/ecm/variables/SearchConstValues";
import SearchUtils from "@/components/search/utilsSearch/UtilsSearch.js";

export default {
  name: "ActionsModal",
  components: {
    SearchCriteriaCondition,
  },
  props: {
    contentTypeId: {
      type: Number,
      required: true,
    },
    contentTypeFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modal: {
        title: this.$t("Actions"),
        key: "actionModalKey",
      },
      open: false,
      conditionItems: [],
    };
  },
  asyncComputed: {
    fieldList: {
      get() {
        return SearchService.getAdvSearchFields(this.contentTypeId).then(
          (data) => data
        );
      },
      default: [],
    },
  },
  methods: {
    edit(actions) {
      this.conditionItems = [];
      actions.forEach((item) => {
        var fieldType = this.fieldList.find(
          (x) => x.Code === item.defFieldCode
        ).Type;

        var conditionStr = `${item.defFieldCode}|s01|${item.value}|${FieldType[fieldType]}`;
        var conditionItem = new ConditionItem(conditionStr);
        this.setDisplayValue(conditionItem);
        this.conditionItems.push(conditionItem);
      });
      this.show();
    },
    setDisplayValue(conditionItem) {
      const context = this
      if (!conditionItem.fieldDisplayValue) {
        conditionItem.fieldDisplayValue = SearchUtils.GetDisplayValueFromFieldValue(
            conditionItem.fieldValue, context
        );
      } else {
        conditionItem.fieldDisplayValue = SearchUtils.GetDisplayValueFromFieldValue(
            conditionItem.fieldDisplayValue, context
        );
      }
    },
    async save() {
      var actions = this.conditionItems.map((x) => {
        var action = new ContentTypeAlertAction();
        action.defFieldCode = x.fieldCode;
        action.value = x.fieldValue;
        return action;
      });
      var uniqueFields = [
        ...new Set(
          this.contentTypeFields
            .filter(
              (f) => f.unique && actions.some((a) => a.defFieldCode == f.code)
            )
            .map((f) => f.name)
        ),
      ];
      if (uniqueFields.length > 0) {
        if (uniqueFields.length > 0) {
          var confirmMessage = this.$t(
            "UniqueFieldsAutomaticActionsWarning"
          ).replaceAll("{0}", uniqueFields.join());

          var res = await this.$confirm(confirmMessage, {
            title: this.$t("Confirm"),
            icon: "mdi-alert",
            color: "warning",
            buttonTrueText: this.$t("Save"),
            buttonFalseText: this.$t("Cancel"),
          });

          if (res != 1) {
            return;
          }
        }
      }
      this.$emit("on-saved", actions);
      this.hide();
    },
    removeAction(item) {
      this.conditionItems = this.conditionItems.filter(
        (f) => f.uuid != item.uuid
      );
    },
    addAction() {
      this.conditionItems.push(new ConditionItem());
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>
